import { useCallback, useMemo } from 'react'

import { useBucket } from '@mc/experiments-react'
import { useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'
import { trackExperimentViewed } from '@mc/track-event'
import { useStaticData } from '@mc/static-data-react'

import { PURCHASE_CTA_COPY_EXP_NAME } from './utils'

export const usePurchaseCtaCopyExperiment = () => {
  const { t } = useTranslation('@mc/growth')

  const { pathname } = useStaticData<{ pathname?: string }>()
  const isQuizResultsPage = pathname === paths.classRecommendationsResults

  const bucket = useBucket(PURCHASE_CTA_COPY_EXP_NAME)
  const isPurchaseCtaCopyVariant =
    bucket?.includes('variant') && !isQuizResultsPage

  const purchaseCopyKey = isPurchaseCtaCopyVariant
    ? `pen-4993_v1.signupCta.${bucket}`
    : 'cta.signup'

  const enhanceableCopies = useMemo(
    () =>
      isPurchaseCtaCopyVariant ? [t('pen-4993_v1.signupCta.variant_2')] : [],
    [t, isPurchaseCtaCopyVariant],
  )

  const trackPurchaseCtaExperiment = useCallback(() => {
    if (!isQuizResultsPage) {
      trackExperimentViewed(PURCHASE_CTA_COPY_EXP_NAME)
    }
  }, [isQuizResultsPage])

  return {
    purchaseCopyKey,
    enhanceableCopies,
    trackPurchaseCtaExperiment,
  }
}
